<template>
    <modal-centered-generic
    :preventClickOutsideClose="preventClickOutsideClose"
    :titleIcon="'add-user'"
    :title="t('transfers.nacional.createBeneficiaryModal.title')"
    :leftButtonText="t('transfers.nacional.createBeneficiaryModal.cancel')"
    :rightButtonText="t('transfers.nacional.createBeneficiaryModal.save')"
    @rightButtonClicked="createBeneficiaryHandler"
    @hideMe="emit('hideMe')">
        <div class="content-container">
            <!-- NaHora message -->
            <text-blocks-generic
            v-if="formTabsList[2].selected"
            :style="{'margin-top': '-32px'}"
            :params="naHoraMessageParams"/>
            <!-- Generic Destination -->
            <text-blocks-generic :params="genericDestinationParams"/>
            <!-- Beneficiary name input -->
            <input-generic
            v-if="formTabsList[2].selected"
            id="beneficiaryName"
            :params="beneficiaryNameInputParams"
            :inputValue="temporaryName"
            @onBlur="beneficiaryNameValidation"
            @input="[temporaryName = $event, clearFieldError()]"/>
            <!-- Beneficiary Name -->
            <text-blocks-generic v-else :params="beneficiaryNameParams"/>
            <!-- TODO PARA A FASE 2 -->
            <!-- Safe Beneficiary -->
            <!-- <switch-text
            :text="t('transfers.nacional.step3.safeBeneficiary')"
            :isActive="safeBeneficiary"
            @clicked="safeBeneficiary = $event"/> -->
            <!-- Safe Beneficiary Warning -->
            <!-- <infobox-generic v-if="safeBeneficiary" :label="t('transfers.nacional.createBeneficiaryModal.alert')"/> -->
        </div>
        <!-- Feedback Toast -->
        <toast-generic
        v-if="showFeedbackToast"
        :toastType="feedbackToastData.toastType"
        :feedbackText="feedbackToastData.text"
        :buttonsParams="feedbackToastData.buttons"
        @hideMe="showFeedbackToast = false"/>
    </modal-centered-generic>
</template>

<script setup>
import ModalCenteredGeneric from '@/components/generic/modals/centered/Generic'
import TextBlocksGeneric from '@/components/generic/textBlocks/Generic'
import ToastGeneric from '@/components/generic/toasts/Generic'
import InputGeneric from '@/components/generic/inputs/Generic'
/* TODO Para a fase 2 */
// import InfoboxGeneric from '@/components/generic/infobox/Generic'
// import SwitchText from '@/components/generic/switch/Text'

/* Vue */
import { ref, computed } from 'vue'

/* Aux */
import { accountFormatHelper, ibanFormat } from '@/assets/scripts/strings'
import { noSpecialCharTransfers, removeAccents } from '@/assets/scripts/validators'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe', 'updateFormData', 'createBeneficiary'])

/** Props
@formData {Object} - Object with form data
@formTabsList {Array} - Tab List for Iban or Account Transfer
@preventClickOutsideClose {Boolean}
*/
const props = defineProps({
    formData: Object,
    formTabsList: Array,
    preventClickOutsideClose: Boolean
})

const safeBeneficiary = ref(false)
const temporaryName = ref(props.formData.beneficiaryName)

const naHoraMessageParams = ref({
    content: t('transfers.nacional.step3.naHoraMessage')
})

const destinationAccount = computed(() => {
    const account = props.formData.genericDestination

    return account.length === 14 ? accountFormatHelper(account) : ibanFormat(account)
})

const genericDestinationParams = computed(() => {
    return {
        label: !props.formTabsList[2].selected ? t('transfers.nacional.genericLabels.genericDestination') : t('transfers.nacional.step3.phoneNumber'),
        content: !props.formTabsList[2].selected ? destinationAccount.value : props.formData.genericDestination.replace(/(?=(?:.{3})*$)/g, ' ')
    }
})

const beneficiaryNameInputParams = ref({
    labelText: t('transfers.nacional.genericLabels.beneficaryName'),
    placeholder: t('transfers.nacional.step1.placeholders.beneficaryName'),
    maxLength: 80,
    ourMask: {
        validatorFn: value => { return noSpecialCharTransfers(value) },
        parseInputText: value => { return removeAccents(value) }
    },
	mandatory: true,
    errorState: false,
    errorMessage: null
})

const beneficiaryNameValidation = () => {
    if (temporaryName.value.length && temporaryName.value.length < 5) {
        beneficiaryNameInputParams.value.errorState = true
        beneficiaryNameInputParams.value.errorMessage = t('transfers.nacional.step1.invalidBeneficiaryName')
    }
}

const clearFieldError = () => {
    beneficiaryNameInputParams.value.errorMessage = null
    beneficiaryNameInputParams.value.errorState = false
}

const beneficiaryNameParams = ref({
    label: t('transfers.nacional.genericLabels.name'),
    content: props.formData.beneficiaryName
})

const createBeneficiaryHandler = name => {
    if (props.formTabsList[2].selected && beneficiaryNameInputParams.value.errorState) return
    emit('createBeneficiary', temporaryName.value)
}

</script>

<style lang="scss" scoped>

.content-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 0;
    gap: 24px;
}
</style>
